import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DropNCrop from '@synapsestudios/react-drop-n-crop';
import { Button, FormGroup } from 'reactstrap';
import { isNil } from 'lodash';
import './DropNCropField.css';
import { setValueToEmptyObject } from '../../modules/ServiceForm/actions';

const DropNCropField = ({
  input,
  meta: { error, touched },
  cropperOptions,
  aspectRatio,
  minCropBoxWidth,
  minCropBoxHeight,
  clearValue,
  ...otherDnDOptions
}) => {
  const showButton = !isNil(input.value.src);
  return (
    <FormGroup>
      {showButton && (
        <Button
          close
          className="close-button position-absolute"
          onClick={clearValue}
        />
      )}
      <DropNCrop
        {...input}
        {...otherDnDOptions}
        cropperOptions={{
          ...cropperOptions,
          aspectRatio,
          minCropBoxWidth,
          minCropBoxHeight
        }}
      />
      <div className="text-danger" style={{ marginBottom: '20px' }}>
        {touched && error}
      </div>
    </FormGroup>
  );
};

DropNCropField.propTypes = {
  /**
   * Aspect ratio for cropper component
   */
  aspectRatio: PropTypes.number,
  /**
   * Object for customizing cropper component, @see https://github.com/roadmanfong/react-cropper
   */
  cropperOptions: PropTypes.object,
  /**
   * Minimal crop box width for cropper component
   */
  minCropBoxWidth: PropTypes.number,
  /**
   * Maximal crop height for cropper component
   */
  minCropBoxHeight: PropTypes.number,
  /**
   * Property provided by redux-form
   */
  input: PropTypes.object
};

const mapDispatchToProps = (dispatch, { input: { name }, meta: { form } }) =>
  bindActionCreators(
    {
      clearValue: setValueToEmptyObject(form, name)
    },
    dispatch
  );

export default connect(
  null,
  mapDispatchToProps
)(DropNCropField);



// WEBPACK FOOTER //
// ./src/components/common/DropNCropField.js